var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._t("default",[_c('v-btn',{attrs:{"color":"primary","disabled":_vm.disabled,"outlined":"","small":""},on:{"click":_vm.download}},[_vm._v("Download student photo")])],{"download":_vm.download})],2)}
var staticRenderFns = []

export { render, staticRenderFns }